const ActionType = {
  ASSIGN: 'Assign',
  UNASSIGN: 'Unassign',
};

export const ActionTypeToTableActionLabel = {
  [ActionType.ASSIGN]: 'Added',
  [ActionType.UNASSIGN]: 'Removed',
};
